import { gql } from "@apollo/client";

export const WORKFLOW_QUERY = gql`
  query documentWorkflows($documentId: Int, $siteId: Int) {
    documentWorkflows(documentId: $documentId, siteId: $siteId) {
      workflowId
      workflowName
      workflowType
      status
      startTime
      endTime
      updateTime
      output
      parentWorkflowId
      reasonForIncompletion
      tasks {
        taskId
        status
        retried
        inputData
        outputData
        taskType
        reasonForIncompletion
        referenceTaskName
        retryCount
        scheduledTime
        startTime
        endTime
        workflowTask {
          name
          type
          taskReferenceName
          decisionCases
          forkTasks {
            name
            type
            taskReferenceName
          }
          defaultCase {
            name
            type
            taskReferenceName
          }
        }
      }
      workflowDefinition {
        description
        restartable
        tasks {
          name
          type
          taskReferenceName
          decisionCases
          forkTasks {
            name
            type
            taskReferenceName
          }
          defaultCase {
            name
            type
            taskReferenceName
          }
        }
      }
    }
  }
`;
